import React from "react";
import { GiDesert } from "react-icons/gi"
import { useHistory } from "react-router-dom";

import { Button, Stack, Box, Heading } from "@chakra-ui/core";

import Footer from "./Footer";


const NotFound = ({ message }) => {
  let history = useHistory();

  function redirectHome() {
    history.push("/");
  }


  return(
    <Box w="100%" h="100vh" bg="#fafafa" display="grid" style={{placeItems:"center"}}>
      <Stack spacing={12} alignItems="center" minW="340px" w="50%">
        <Box as={GiDesert} size="300px" color="danger.transparent-600" />
        <Heading textAlign="center" as="h2" size="xl" color="primary.400">
          Sorry we could not find what you are looking for.
        </Heading>
        <Button _hover={{bg:"success.600"}} onClick={redirectHome} bg="success.400" color="#fff" size="lg" fontWeight="bold">Back to a known place</Button>
      </Stack>
      <Footer />
    </Box>
  )
};

export default NotFound;
